/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Supplier = {
  /**
   * Unique supplier identifier
   */
  id: number;
  /**
   * Supplier name
   */
  name: string;
  /**
   * Supplier address
   */
  address?: string;
  /**
   * Supplier phone number
   */
  phone?: string;
  /**
   * Supplier email
   */
  email?: string;
  /**
   * Contact person name
   */
  contactPerson?: string;
  /**
   * Supplier description
   */
  description?: string;
  /**
   * Supplier status
   */
  status: Supplier.status;
  /**
   * Registration date
   */
  registrationDate: string;
};
export namespace Supplier {
  /**
   * Supplier status
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
  }
}
